import { ISummerCampForm } from "container/summer-camp/summer-camp-sections/application-form/i-application-form";
import { IAddSummerCamp } from "pages/admin/summer-camp/add";
import { Http } from "services/http/http";
import { paramsObjectToQueryString } from "utils/generic-utils";

export const fetchSummerCamps = (payload?: {}) =>
   Http.get(`/summer-school${paramsObjectToQueryString(payload)}`);
export const fetchSummerCampRequest = (payload?: {}) =>
   Http.get(`/summer-school/application${paramsObjectToQueryString(payload)}`);
export const fetchAllSummerCamps = (payload?: {}) =>
   Http.get(
      `/summer-school${paramsObjectToQueryString({
         page: 1,
         limit: "none",
         ...payload,
      })}`
   );
export const createSummerCamp = (payload: IAddSummerCamp) => Http.post("/summer-school", payload);
export const updateSummerCamp = (id: string, payload: IAddSummerCamp) =>
   Http.put(`/summer-school/${id}`, payload);
export const deleteSummerCamp = (id: string) => Http.delete(`/summer-school/${id}`);
export const fetchSingleSummerCamp = (token, { queryKey }) =>
   Http.get(`/summer-school/${queryKey[1]}`, {
      headers: {
         authorization: token,
      },
   });
export const applyToSummerCamp = (id: string, payload: ISummerCampForm) =>
   Http.post(`/summer-school/${id}/apply`, payload);

export const fetchSchoolSummerCamps = (payload?: {}) =>
   Http.get(`/summer-school/sch-admin${paramsObjectToQueryString(payload)}`);
